import React from 'react';
import DefaultTooltip from '../Tooltips/DefaultTooltip';

interface TruncatedTextProps {
  text: string;
  limit?: number;
}

const TruncatedText: React.FC<TruncatedTextProps> = ({
  text,
  limit = 20,
}) => {
  const isTruncated = text.length > limit;
  const displayText = isTruncated
    ? `${text.slice(0, limit)}...`
    : text;

  return (
    <>
      {isTruncated ? (
        <DefaultTooltip title={text}>
          <>{displayText}</>
        </DefaultTooltip>
      ) : (
        displayText
      )}
    </>
  );
};

export default TruncatedText;
